<div class="section">
    <div [matTooltip]="newMarginCalcTooltip()">
        <button mat-button
            [disabled]="disableNewMarginCalc()"
            data-qa-id="an_rjd_newmargin_button"
            *ngIf="showCreateMarginCalculator && isUserAllowedToCreateMargin"
            (click)="createNewMargin(job.id)">
            <img src="assets/images/svg/calculator.svg"
                alt="calculate">
            Create New MC
        </button>
    </div>
    <div>
        <button mat-button
            data-qa-id="an_rjd_linkmargin_button"
            (click)="linkMargin(job.id)"
            *ngIf="showSampleMargin">
            <img src="assets/images/svg/calculator.svg"  alt="calculate">
            Link Margin
        </button>
    </div>
    <div>
        <button mat-button
            data-qa-id="an_rjd_samplemargin_button"
            (click)="sampleMargin(job.id, job.sampleMarginId)"
            *ngIf="job.sampleMarginId">
            <img src="assets/images/svg/calculator.svg" alt="calculate">
            Sample Margin
        </button>
    </div>
    <div>
        <nova-atm-button [jobId]="job.id"></nova-atm-button>
    </div>
</div>